import Header from "./components/Header";
import Banner from "./components/Banner";
import Accordion from "./components/Accordion";
import Footer from "./components/Footer";
import ThreeColumns from "./components/ThreeColumns";
import imagen1 from "./img/gif-celular.gif";
import oportunidaddes from "./img/oportunidades.gif";
import consejero from "./img/consejero.gif";
import CompetenciaComponent from "./components/CompetenciaComponent";

import paso1 from "./img/paso1.png";
import paso2 from "./img/paso2_tec.png";
import paso3 from "./img/paso3.png";

function App() {
  const competencia1 = [
    {
      id: 1,
      titulo: "Desarrollar productos comunicacionales multimedia",
      asignaturas: [
        {
          nombre: "Herramientas en tecnología móvil",
          evidencias: [
            {
              tipo: "Certificado / Taller",
              items: [
                "Certificado de marketing móvil o mobile Apps.",
                "Certificado/Taller de diseño de apps móviles.",
                "Certificado de User Experience o Design Thinking.",
                "Taller práctico de WhatsApp Business, SMS marketing y uso de Apps de mensajería.",
              ],
            },
          ],
        },
        {
          nombre: "Diseño gráfico y fotografía digital",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Portafolio con piezas gráficas y fotografías conceptuales",
                "Certificado de experiencia de clientes o empresa",
              ],
            },
          ],
        },

        {
          nombre: "Negocios Digitales",
          evidencias: [
            {
              tipo: "Certificado / Taller / Portafolio",
              items: [
                "Certificado en fundamentos de negocios digitales",
                "Taller de tecnologías SMAC (Social, Mobility, Analytics, Cloud)",
                " Portafolio de análisis de caso de negocio digital",
              ],
            },
          ],
        },

        {
          nombre: "Metodología de la investigación y técnicas de estudio",
          evidencias: [
            {
              tipo: "Certificado / Informe académico",
              items: [
                "Certificado de curso de investigación científica. ",
                "Ensayo o artículo académico publicado",
                " Informe de búsqueda sistemática en bases de datos",
              ],
            },
          ],
        },

        {
          nombre: "Producción y edición de audiovisual para entornos digitales",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificado de software de edición (Premiere, Final Cut)",
                " Muestra de productos audiovisuales para web (portafolio)",
                "Certificados de trabajo en áreas afines a la producción audiovisual (productoras o medios audiovisuales legalmente constituidos)",
              ],
            },
          ],
        },
        {
          nombre: "Prácticum 1",
          evidencias: [
            {
              tipo: "Informe profesional",
              items: [
                "Reconocimiento del Prácticum 1, 2 y 3 a través de experiencia laboral",
              ],
            },
          ],
        },
      ],
    },
  ];
  const competencia2 = [
    {
      id: 2,
      titulo: "Diagnosticar la gestión de la comunicación y marketing digital",
      asignaturas: [
        {
          nombre: "Marketing digital",
          resultado_aprendizaje:
            "Implementa la estrategia de marketing digital en la empresa a partir de las acciones identificadas, para fortalecer su posicionamiento digital.",
          evidencias: [
            {
              tipo: "Certificado / Taller",
              items: [
                "Certificación Google Ads o SEM.",
                "Taller de SEO.",
                "Evidencias de campañas de email marketing o embudos de conversión.",
              ],
            },
          ],
        },
        {
          nombre: "Contenidos multimedia y trasmedia",
          resultado_aprendizaje:
            "Determina la estrategia de contenido multimedia y transmedia, en función de la estrategia global de comunicación.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificado en narrativas transmedia.",
                "Muestras de contenidos hipermedia y crossmedia (portafolio).",
              ],
            },
          ],
        },
        {
          nombre: "Estrategias de comunicación en redes sociales",
          resultado_aprendizaje:
            "Identifica proyectos digitales e interactivos, cuyos contenidos puedan ser adaptados a distintos contextos culturales, para ser distribuidos a través de diferentes canales y plataformas.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificado de Social Media Marketing.",
                "Plan de contenidos y métricas de una campaña real (portafolio).",
              ],
            },
          ],
        },
        {
          nombre: "Prácticum 2",
          resultado_aprendizaje:
            "Establece técnicas de investigación para el levantamiento de información que contribuya al diagnóstico comunicacional del escenario real.",
          evidencias: [
            {
              tipo: "Informe profesional",
              items: [
                "Reconocimiento del Prácticum 1, 2 y 3 a través de experiencia laboral.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia3 = [
    {
      id: 3,
      titulo:
        "Emplear estrategias y herramientas de marketing digital actuales",
      asignaturas: [
        {
          nombre: "Interoperabilidad empresarial",
          resultado_aprendizaje:
            "Integra diferentes productos o sistemas computarizados para conectarse e intercambiar fácilmente información entre sí, ya sea en la implementación o el acceso, sin restricciones.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificados de formación técnica relacionada con el uso de APIS.",
                "Evidencia de proyectos reales o laborales con integración de sistemas.",
                "Demo funcional de una integración realizada.",
                "Informes o propuestas estratégicas donde se planifica interoperabilidad (CRM + redes sociales + analítica).",
                "Estrategia digital donde se detallan flujos de automatización e interoperabilidad.",
                "Experiencia comprobable en herramientas específicas como Zapier, Make, Integromat, n8n, Power Automate, etc.",
              ],
            },
          ],
        },
        {
          nombre: "Desarrollo web",
          resultado_aprendizaje:
            "Relaciona estratégicamente las herramientas web, que permitan mejorar la usabilidad y experiencia del usuario.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificación en desarrollo front-end (HTML/CSS/JS).",
                "Enlace a landing page o proyecto web desarrollado.",
              ],
            },
          ],
        },
        {
          nombre: "Herramientas de medición y Control",
          resultado_aprendizaje:
            "Aplica diferentes técnicas de análisis de medición y evaluación, para ejecutar campañas de marketing digital.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificado de Google Analytics (GA4).",
                "Certificación en analítica social (Meta, Hootsuite o Sprout Social).",
                "Certificación de Google Data Studio / Looker Studio.",
                "Certificación SEMrush o Ahrefs (SEO).",
                "Dashboard de monitoreo con métricas clave interpretadas.",
                "Informe de auditoría SEO + redes sociales con hallazgos y propuesta de mejora.",
                "Análisis completo del diagnóstico de una marca (auditorías).",
                "Bitácora o portafolio de uso de herramientas de analítica web y social.",
                "Informe de participación en proyectos reales firmado por el tutor profesional.",
              ],
            },
          ],
        },
        {
          nombre: "Social media marketing",
          resultado_aprendizaje:
            "Relaciona los elementos y herramientas del social media, para la implementación de la estrategia de marketing digital de la empresa.",
          evidencias: [
            {
              tipo: "Certificado / Caso de estudio",
              items: [
                "Certificado en Social Media Ads.",
                "Estudio de caso de campaña de influencers o análisis de tendencias.",
                "Elaboración de Social Media Plan.",
                "Elaboración de productos audiovisuales para redes sociales.",
              ],
            },
          ],
        },
        {
          nombre: "Prácticum 3",
          resultado_aprendizaje:
            "Desarrolla proyectos comunicacionales digitales de servicio comunitario.",
          evidencias: [
            {
              tipo: "Informe profesional / Certificado de servicio comunitario",
              items: [
                "Reconocimiento del Prácticum 1, 2 y 3 a través de experiencia laboral.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia4 = [
    {
      id: 4,
      titulo:
        "Planificar y desarrollar estrategias de marketing y comunicación digital",
      asignaturas: [
        {
          nombre: "Estrategias y plataformas de ecommerce",
          resultado_aprendizaje:
            "Aplica acciones para generar estrategias de comercio electrónico en las organizaciones.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificación en e-commerce fundamentales.",
                "Análisis comparativo de plataformas (Shopify, WooCommerce) con recomendaciones.",
                "Desarrollo de software.",
              ],
            },
          ],
        },
        {
          nombre: "Gestión de relaciones y comportamiento del consumidor",
          resultado_aprendizaje:
            "Distingue las nuevas tendencias de consumo y las necesidades del consumidor, a través de herramientas y plataformas digitales, para la generación de nuevas propuestas de fidelización para el cliente.",
          evidencias: [
            {
              tipo: "Certificado / Caso de CRM",
              items: [
                "Certificado en CRM (Salesforce, HubSpot).",
                "Caso de fidelización con métricas de inbound/permissive marketing (informe).",
              ],
            },
          ],
        },
        {
          nombre: "Emprendimiento digital",
          resultado_aprendizaje:
            "Crea y evalúa oportunidades de negocio para ecosistema digital.",
          evidencias: [
            {
              tipo: "Certificado / Plan de negocio",
              items: [
                "Certificado de incubadora o aceleradora digital.",
                "Plan de negocio digital con prototipo y lanzamiento (documento).",
              ],
            },
          ],
        },
        {
          nombre: "Publicidad digital",
          resultado_aprendizaje:
            "Organiza e implementa la estrategia creativa para el desarrollo de campañas digitales específicas y efectivas.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Portafolio de campañas digitales (estrategia creativa).",
                "Certificados de formación.",
                "Talleres o cursos en marketing digital, planificación y elaboración de campañas: Meta Ads, Google Ads, etc.",
              ],
            },
          ],
        },
        {
          nombre: "Comunicación estratégica digital",
          resultado_aprendizaje:
            "Interpreta el diagnóstico de la organización, para definir la estrategia de comunicación digital.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificado en estrategia digital 360°.",
                "Diagnóstico y plan estratégico de comunicación para una organización real (documento).",
              ],
            },
          ],
        },
      ],
    },
  ];

  const bimcompetencia1 = [
    {
      id: 1,
      titulo:
        "Manejar el proceso contractual en base a la legislación, relacionando materiales básicos y el sitio, introduciéndose a la metodología BIM",
      asignaturas: [
        {
          nombre: "Topografía Básica",
          resultadoAprendizaje:
            "Aplica principios básicos de topografía para analizar el sitio del proyecto, integrando los fundamentos de la metodología BIM.",
          evidencias: [
            {
              tipo: "Certificados laborales / Portafolio / Cursos",
              items: [
                "Certificados laborales en empresas de construcción, consultoras de ingeniería o entidades gubernamentales (levantamientos topográficos, control de materiales, supervisión de obra, aplicación de BIM, gestión contractual).",
                "Portafolio de experiencia en topografía y/o proyectos constructivos.",
                "Cursos o capacitaciones en topografía aplicada a la construcción e integración con BIM.",
              ],
            },
          ],
        },
        {
          nombre: "Fundamentos de la metodología BIM",
          resultadoAprendizaje:
            "Aplica principios básicos de topografía para analizar el sitio del proyecto, integrando los fundamentos de la metodología BIM.",
          evidencias: [
            {
              tipo: "Certificaciones / Cursos",
              items: [
                "Certificaciones en fundamentos de BIM (ISO 19650, BEP, roles BIM, flujos de trabajo).",
                "Cursos o capacitaciones en BIM aplicado a modelado, coordinación y gestión de información.",
              ],
            },
          ],
        },
        {
          nombre: "Materiales de Construcción",
          resultadoAprendizaje:
            "Identifica los materiales que interactúan en un proceso constructivo.",
          evidencias: [
            {
              tipo: "Certificaciones / Cursos",
              items: [
                "Certificaciones en ensayos y control de materiales (concreto, acero, suelos, asfaltos, mampostería, etc.).",
                "Cursos o capacitaciones en tecnología de materiales y normas de construcción y sostenibilidad.",
              ],
            },
          ],
        },
        {
          nombre: "Fundamentos de la Legislación y documentación contractual",
          resultadoAprendizaje:
            "Organiza la documentación requerida para un proceso contractual, aplicando la legislación vigente.",
          evidencias: [
            {
              tipo: "Certificaciones / Cursos / Experiencia laboral",
              items: [
                "Certificaciones en normativas de construcción y contratación (FIDIC, NEC, ISO 19650 aplicada a contratos BIM, normativa local de contratación pública).",
                "Cursos o capacitaciones en gestión contractual y legislación de construcción (licitaciones, permisos, normativas de obra).",
                "Certificados laborales relacionados con gestión contractual en proyectos de construcción.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const bimcompetencia2 = [
    {
      id: 2,
      titulo:
        "Dominar los procesos constructivos de calidad, entendiendo las posibles amenazas, así como las medidas tanto ambientales como de seguridad que deben implementarse",
      asignaturas: [
        {
          nombre: "Procesos Constructivos",
          resultadoAprendizaje:
            "Evalúa procesos constructivos de calidad, considerando amenazas ambientales y de seguridad, implementando medidas de prevención y mitigación.",
          evidencias: [
            {
              tipo: "Certificados laborales / Contratos / Memorias técnicas / Cursos",
              items: [
                "Certificados laborales emitidos por empresas de construcción, infraestructura hidráulica o entidades afines, indicando cargo y funciones (procesos constructivos, gestión de riesgos, seguridad, calidad o ambiente).",
                "Contratos o facturas que acrediten experiencia independiente en construcción o supervisión de obras.",
                "Memorias técnicas de obras en las que haya participado.",
                "Certificaciones de cursos en procesos constructivos y construcción en general.",
              ],
            },
          ],
        },
        {
          nombre: "Evaluación de Amenazas para Proyectos de Infraestructura",
          resultadoAprendizaje:
            "Describe las amenazas que pueden incidir en el normal desarrollo de una construcción.",
          evidencias: [
            {
              tipo: "Informes técnicos / Cursos / Certificaciones",
              items: [
                "Informes técnicos de evaluación de amenazas o gestión de riesgos en proyectos de infraestructura.",
                "Certificaciones o capacitaciones en gestión de riesgos y prevención de amenazas en infraestructura.",
                "Registro de capacitaciones en manejo de riesgos en la construcción.",
              ],
            },
          ],
        },
        {
          nombre: "Fundamentos de Hidráulica",
          resultadoAprendizaje:
            "Evalúa procesos constructivos de calidad, considerando amenazas ambientales y de seguridad, implementando medidas de prevención y mitigación.",
          evidencias: [
            {
              tipo: "Certificados laborales / Cursos / Memorias técnicas",
              items: [
                "Certificados laborales relacionados con obras hidráulicas (agua potable, alcantarillado, drenajes, riego, etc.).",
                "Cursos o capacitaciones en hidráulica aplicada a la construcción.",
                "Memorias técnicas de proyectos hidráulicos en los que haya participado.",
              ],
            },
          ],
        },
        {
          nombre: "Gestión de calidad, seguridad industrial y manejo ambiental",
          resultadoAprendizaje:
            "Implementa medidas de seguridad en obra, asegurando prácticas responsables y calidad en los proyectos.",
          evidencias: [
            {
              tipo: "Certificaciones / Planes / Licencias",
              items: [
                "Certificaciones en normativas de calidad, seguridad y ambiente (ISO 9001, ISO 14001, ISO 45001, OSHA, entre otras).",
                "Planes de seguridad y salud ocupacional en los que haya participado o elaborado.",
                "Licencias o acreditaciones profesionales en seguridad, calidad o gestión ambiental (si aplica).",
                "Registro de capacitaciones adicionales en seguridad industrial, gestión ambiental y control de calidad.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const bimcompetencia3 = [
    {
      id: 3,
      titulo:
        "Crear modelos tridimensionales detallados en diversas disciplinas (arquitectura, estructuras, instalaciones MEP, obras viales e hidráulicas) para proyectos de construcción.",
      asignaturas: [
        {
          nombre: "Modelado de proyecto Arquitectónico",
          resultadoAprendizaje:
            "Desarrolla técnicas de representación especializadas para proyectos constructivos multidisciplinarios, integrando aspectos arquitectónicos, estructurales, MEP, viales e hidráulicos, respetando las normas vigentes.",
          evidencias: [
            {
              tipo: "Certificados laborales / Cursos / Memorias técnicas",
              items: [
                "Certificados laborales en estudios de arquitectura, ingenierías o empresas de construcción, donde haya trabajado en modelado de proyectos.",
                "Certificados de cursos o capacitaciones en modelado BIM y representación arquitectónica.",
                "Acreditaciones en normativas vigentes relacionadas con modelado y representación gráfica en construcción (normas ISO BIM, reglamentos locales).",
                "Memorias técnicas que expliquen los criterios aplicados en el modelado.",
              ],
            },
          ],
        },
        {
          nombre: "Modelado de proyecto Estructural",
          resultadoAprendizaje:
            "Desarrolla técnicas de representación especializadas para proyectos constructivos multidisciplinarios, integrando aspectos arquitectónicos, estructurales, MEP, viales e hidráulicos, respetando las normas vigentes.",
          evidencias: [
            {
              tipo: "Certificados laborales / Cursos / Memorias técnicas",
              items: [
                "Certificados laborales en modelado estructural de proyectos.",
                "Certificados de cursos o capacitaciones en modelado estructural BIM.",
                "Acreditaciones en normativas vigentes aplicadas al modelado estructural.",
                "Memorias técnicas de proyectos estructurales desarrollados.",
              ],
            },
          ],
        },
        {
          nombre: "Modelado instalaciones MEP",
          resultadoAprendizaje:
            "Desarrolla técnicas de representación especializadas para proyectos constructivos multidisciplinarios, integrando aspectos arquitectónicos, estructurales, MEP, viales e hidráulicos, respetando las normas vigentes.",
          evidencias: [
            {
              tipo: "Certificados laborales / Cursos / Memorias técnicas",
              items: [
                "Certificados laborales en modelado de instalaciones MEP.",
                "Certificados de cursos o capacitaciones en modelado BIM aplicado a instalaciones MEP.",
                "Acreditaciones en normativas vigentes relacionadas con modelado de instalaciones.",
                "Memorias técnicas de proyectos MEP desarrollados.",
              ],
            },
          ],
        },
        {
          nombre: "Modelado de proyecto de obra vial e hidráulico",
          resultadoAprendizaje:
            "Desarrolla técnicas de representación especializadas para proyectos constructivos multidisciplinarios, integrando aspectos arquitectónicos, estructurales, MEP, viales e hidráulicos, respetando las normas vigentes.",
          evidencias: [
            {
              tipo: "Certificados laborales / Cursos / Memorias técnicas",
              items: [
                "Certificados laborales en modelado de proyectos viales e hidráulicos.",
                "Certificados de cursos o capacitaciones en modelado BIM aplicado a obras viales e hidráulicas.",
                "Acreditaciones en normativas vigentes relacionadas con representación gráfica en infraestructura vial e hidráulica.",
                "Memorias técnicas de proyectos viales e hidráulicos desarrollados.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const bimcompetencia4 = [
    {
      id: 4,
      titulo:
        "Supervisar la colaboración, coordinación y calidad en proyectos con Metodología BIM, relacionándose con la infraestructura tecnológica y control eficiente de información, visualizando nuevas oportunidades de emprendimiento en la construcción",
      asignaturas: [
        {
          nombre:
            "Colaboración, coordinación y control de calidad en Proyectos",
          resultadoAprendizaje:
            "Relaciona las disciplinas de un proyecto utilizando la metodología BIM, considerando la infraestructura tecnológica y la información disponible.",
          evidencias: [
            {
              tipo: "Certificados laborales / Certificaciones BIM / Software / Experiencia técnica",
              items: [
                "Certificados laborales en empresas de tecnología aplicada a la construcción, gestión de infraestructura TI, roles de coordinación BIM, control de calidad en construcción o gestión de equipos multidisciplinarios.",
                "Certificaciones y acreditaciones en normas y estándares BIM (ISO 19650, openBIM, BEP – BIM Execution Plan, PAS 1192, COBie, BCF) y en seguridad y almacenamiento de datos.",
                "Certificaciones en software y plataformas BIM (Revit, Navisworks, Solibri, BIMCollab, BCF Manager, Autodesk Construction Cloud, BIM 360, Trimble Connect, Dalux, Aconex, Bimsync).",
                "Capacitaciones en coordinación de disciplinas y metodologías de colaboración digital en proyectos de construcción (arquitectura, estructuras, MEP, viales, hidráulicas).",
                "Experiencia en modelos federados de coordinación e informes de detección y resolución de interferencias.",
                "Cursos y certificaciones en gestión de infraestructura tecnológica, interoperabilidad, mantenimiento de sistemas, virtualización y colaboración (VMWare, AWS, Azure, servidores NAS).",
                "Desarrollo de un modelo de negocio basado en BIM y presentación de casos de estudio reales.",
                "Documentación legal de emprendimiento (copia de RUC, RUP).",
              ],
            },
          ],
        },
      ],
    },
  ];

  const bimcompetencia5 = [
    {
      id: 5,
      titulo:
        "Desarrollar la planificación, presupuestos y control de obras civiles en proyectos de construcción con BIM, garantizando eficiencia y calidad en todas las etapas del proyecto.",
      asignaturas: [
        {
          nombre:
            "Gestión y Planificación de proyectos de construcción (PEB) 4D BIM",
          resultadoAprendizaje:
            "Diseña la planificación de las diferentes etapas del proceso constructivo, utilizando la metodología BIM para garantizar eficiencia y calidad.",
          evidencias: [
            {
              tipo: "Certificados laborales / Software BIM 4D / Cursos / Experiencia documentada",
              items: [
                "Certificados laborales en gestión de proyectos, planificación de obras, implementación de BIM en fases de construcción, planificación financiera o supervisión de obra bajo metodología BIM.",
                "Certificaciones en software BIM 4D (Navisworks, Synchro 4D, Primavera P6 con integración BIM, BIM 360).",
                "Cursos o capacitaciones en planificación BIM y Lean Construction (Last Planner System, VDC, metodología 4D BIM).",
                "Acreditaciones en normativas y estándares BIM aplicables a la gestión y planificación (ISO 19650, PAS 1192, BIM Execution Plan – BEP).",
                "Experiencia documentada en diseño de la planificación de proyectos con metodología BIM 4D.",
              ],
            },
          ],
        },
        {
          nombre: "Presupuestos de obras de construcción 5D",
          resultadoAprendizaje:
            "Evalúa de manera eficiente el presupuesto y recursos de proyectos de construcción, implementando metodología BIM.",
          evidencias: [
            {
              tipo: "Certificaciones BIM 5D / Cursos / Normativas / Experiencia profesional",
              items: [
                "Certificaciones en software BIM 5D (Cost It, Presto, Vico Office, Revit con Autodesk Takeoff, Navisworks Quantification, Arquímedes).",
                "Cursos o capacitaciones en presupuestos y costos en BIM con integración de modelos a bases de datos de costos.",
                "Acreditaciones en estándares como COBie, NUPC (Nomenclatura Uniforme de Precios de Construcción) y estándares de Facility Management.",
                "Experiencia en control de costos, gestión de mantenimiento o control de calidad en construcción bajo metodología BIM.",
                "Cursos o capacitaciones en mantenimiento de infraestructura y normativas de operación.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia1_ventas = [
    {
      id: 1,
      titulo:
        "Aplicar de manera efectiva los principios administrativos en la gestión de ventas, sustentada en valores éticos y un liderazgo inspirador.",
      asignaturas: [
        {
          nombre: "Estrategias de Ventas y negociación",
          resultadoAprendizaje:
            "Implementa estrategias de liderazgo para llevar a cabo ventas efectivas, construir relaciones sólidas con los clientes y promover el crecimiento y éxito sostenible de la empresa.",
          evidencias: [
            {
              tipo: "Informe de actividades / Certificado de capacitación",
              items: [
                "Informe de actividades que demuestre la aplicación de estrategias de ventas efectivas y acciones de fidelización de clientes, con evidencias concretas, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en estrategias de ventas y negociación (mínimo 192 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Gestión del liderazgo en ventas",
          resultadoAprendizaje:
            "Implementa estrategias de liderazgo para llevar a cabo ventas efectivas, construir relaciones sólidas con los clientes y promover el crecimiento y éxito sostenible de la empresa.",
          evidencias: [
            {
              tipo: "Informe de actividades / Certificado de capacitación",
              items: [
                "Informe de actividades que evidencie la aplicación de estilos y estrategias de liderazgo en ventas, demostrando dirección de equipos hacia objetivos comerciales, con evidencias, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en liderazgo en ventas (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Competencias humanas para el futuro",
          resultadoAprendizaje:
            "Propone soluciones innovadoras en la gestión de cuentas clave, aplicando técnicas de comunicación persuasiva para fortalecer las relaciones con los clientes y potenciar los resultados comerciales.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "Esta asignatura no se reconoce para proceso de validación por evidencias.",
              ],
            },
          ],
        },
        {
          nombre: "Gestión Empresarial y Teorías de la Organización",
          resultadoAprendizaje:
            "Aplica herramientas y técnicas financieras y presupuestarias para gestionar los recursos de la empresa de manera responsable y maximizar su valor económico.",
          evidencias: [
            {
              tipo: "Informe de actividades / Certificado de capacitación",
              items: [
                "Informe de actividades que evidencie la aplicación de herramientas de análisis y gestión empresarial (FODA, PESTEL, planificación estratégica, gestión de procesos), con evidencias, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en gestión empresarial (mínimo 144 horas).",
              ],
            },
          ],
        },
      ],
    },
  ];
  const competencia2_comercial = [
    {
      id: 2,
      titulo:
        "Analizar responsablemente datos demográficos, comportamentales y de mercado para gestionar relaciones estratégicas con los clientes y diseñar estrategias comerciales que impulsen el crecimiento empresarial.",
      asignaturas: [
        {
          nombre: "Investigación de mercados",
          resultadoAprendizaje:
            "Realiza investigaciones de mercado y gestiona las relaciones con los clientes para contribuir al crecimiento sostenible de la empresa.",
          evidencias: [
            {
              tipo: "Informe de investigación / Certificado de capacitación",
              items: [
                "Informe de investigación de mercados que incluya análisis del entorno, diseño y aplicación de encuestas o entrevistas, análisis de resultados y propuestas de crecimiento sostenible, con evidencias, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en investigación de mercados (mínimo 192 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Gestión de Relaciones con el Cliente",
          resultadoAprendizaje:
            "Diseña estrategias comerciales y de marketing efectivas para contribuir al crecimiento y éxito empresarial.",
          evidencias: [
            {
              tipo: "Informe de gestión / Certificado de capacitación",
              items: [
                "Informe de gestión de relaciones con clientes que evidencie estrategias de adquisición, fidelización, resolución de quejas y análisis de indicadores de desempeño, con evidencias reales, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en Gestión de relaciones con el cliente (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Emprendimiento e Innovación",
          resultadoAprendizaje:
            "Emplea la creatividad para generar ideas de negocio innovadoras que impulsen el desarrollo empresarial.",
          evidencias: [
            {
              tipo: "Informe de emprendimiento / Certificado de capacitación",
              items: [
                "Informe que evidencie aplicación de habilidades emprendedoras, identificación de tendencias y oportunidades, diseño de proceso creativo e innovador y formulación de modelo de negocio viable, con evidencias documentales, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en Emprendimiento (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Inteligencia de Negocios",
          resultadoAprendizaje:
            "Utiliza herramientas tecnológicas en Business Analytics, Big Data y estadística aplicada para visualizar datos y generar informes ejecutivos que faciliten la toma de decisiones.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "Esta asignatura no se reconoce para proceso de validación por evidencias.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia3_comercial = [
    {
      id: 3,
      titulo:
        "Utiliza tecnologías de la información en la gestión comercial y de ventas para fortalecer y mejorar las relaciones con los clientes, alineando las estrategias comerciales con los objetivos organizacionales.",
      asignaturas: [
        {
          nombre: "Marco estratégico comercial",
          resultadoAprendizaje:
            "Diseña estrategias comerciales y de marketing efectivas para contribuir al crecimiento y éxito empresarial.",
          evidencias: [
            {
              tipo: "Informe estratégico / Certificado de capacitación",
              items: [
                "Informe que integre estrategias comerciales con los objetivos generales de la organización, demostrando contribución al crecimiento y sostenibilidad, con evidencias documentales, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en Marco Estratégico Comercial (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Marketing Intelligence",
          resultadoAprendizaje:
            "Diseña estrategias comerciales y de marketing efectivas para contribuir al crecimiento y éxito empresarial.",
          evidencias: [
            {
              tipo: "Informe de aplicación / Certificado de capacitación",
              items: [
                "Informe de aplicación de Marketing que evidencie recolección, análisis e interpretación de datos de mercado para diseñar estrategias efectivas, con evidencias reales, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en Marketing (mínimo 192 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Gestión Financiera y Presupuestaria",
          resultadoAprendizaje:
            "Aplica herramientas y técnicas financieras y presupuestarias para gestionar los recursos de la empresa de manera responsable y maximizar su valor económico.",
          evidencias: [
            {
              tipo: "Informe financiero / Certificado de capacitación",
              items: [
                "Informe que evidencie aplicación de herramientas financieras y presupuestarias para gestión responsable de recursos y toma de decisiones estratégicas, con evidencias reales, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en Gestión Financiera y Presupuestaria (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Software aplicado a la gestión de los negocios",
          resultadoAprendizaje:
            "Utiliza software especializados en el ámbito empresarial para optimizar procesos, gestionar información y mejorar la toma de decisiones en diferentes áreas funcionales de una organización.",
          evidencias: [
            {
              tipo: "Informe de gestión CRM / Certificado de capacitación",
              items: [
                "Informe de gestión con CRM (Customer Relationship Management) que evidencie implementación de estrategias y uso de herramientas tecnológicas para optimizar procesos comerciales, mejorar experiencia del cliente y fortalecer fidelización, con evidencias reales, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en CRM (mínimo 144 horas).",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia4_comercial = [
    {
      id: 4,
      titulo:
        "Desarrolla estrategias integrales de gestión de cuentas claves y habilidades de comunicación efectiva para maximizar el valor de los clientes y potenciar las relaciones comerciales.",
      asignaturas: [
        {
          nombre: "Gestión de cuentas claves",
          resultadoAprendizaje:
            "Propone soluciones innovadoras en la gestión de cuentas clave, aplicando técnicas de comunicación persuasiva para fortalecer las relaciones con los clientes y potenciar los resultados comerciales.",
          evidencias: [
            {
              tipo: "Informe de gestión / Certificado de capacitación",
              items: [
                "Informe que evidencie la aplicación de estrategias y tácticas para maximizar el valor de clientes estratégicos y acciones de retención, con evidencias reales, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en Gestión de cuentas claves (mínimo 192 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Comunicación estratégica y técnicas de negociación",
          resultadoAprendizaje:
            "Propone soluciones innovadoras en la gestión de cuentas clave, aplicando técnicas de comunicación persuasiva para fortalecer las relaciones con los clientes y potenciar los resultados comerciales.",
          evidencias: [
            {
              tipo: "Informe aplicado / Certificado de capacitación",
              items: [
                "Informe que evidencie la aplicación de principios de comunicación estratégica y técnicas avanzadas de negociación para resolver conflictos y alcanzar acuerdos beneficiosos, con evidencias reales, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en Comunicación estratégica y técnicas de negociación (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Estadística aplicada a los negocios",
          resultadoAprendizaje:
            "Utiliza herramientas tecnológicas en Business Analytics, Big Data y estadística aplicada para visualizar datos y generar informes ejecutivos que faciliten la toma de decisiones.",
          evidencias: [
            {
              tipo: "Informe estadístico / Certificado de capacitación",
              items: [
                "Informe que evidencie aplicación de técnicas estadísticas descriptivas e inferenciales en análisis de datos empresariales para toma de decisiones, con evidencias reales, firmas, sello institucional y declaración juramentada.",
                "Certificado de capacitación en Estadística aplicada a los negocios (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Gestión Basada en Datos y Análisis Empresarial",
          resultadoAprendizaje:
            "Utiliza herramientas tecnológicas en Business Analytics, Big Data y estadística aplicada para visualizar datos y generar informes ejecutivos que faciliten la toma de decisiones.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "Esta asignatura no se reconoce para proceso de validación por evidencias.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia1_turismo = [
    {
      id: 1,
      titulo:
        "Desarrollar una comprensión integral de la oferta turística actual, aplicando análisis situacionales y técnicas de evaluación para identificar oportunidades y retos, utilizando la sostenibilidad y la innovación como ejes transversales para el diseño de experiencias turísticas digitales.",
      asignaturas: [
        {
          nombre: "Turismo Digital y Sostenible",
          resultadoAprendizaje:
            "Evalúa los fundamentos del turismo digital y sostenible, y desarrolla estrategias de marketing digital, identificando oportunidades de emprendimiento innovador.",
          evidencias: [
            {
              tipo: "Informe / Portafolio / Certificado laboral / Certificados académicos",
              items: [
                "Informe, portafolio o certificado laboral que evidencie participación en proyectos turísticos con enfoque digital o sostenible, promoción de destinos, innovación en servicios o diseño de experiencias turísticas.",
                "Evidencias documentales, declaración juramentada y/o certificado de trabajo.",
                "Certificados en sostenibilidad turística, turismo responsable, marketing turístico o innovación en servicios (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Emprendimiento e Innovación",
          resultadoAprendizaje:
            "Analiza y diseña productos turísticos basados en la valoración del patrimonio nacional, enfocados en la innovación y sostenibilidad.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "Esta asignatura no es validable por proceso de reconocimiento de evidencias.",
              ],
            },
          ],
        },
        {
          nombre: "Marketing Digital",
          resultadoAprendizaje:
            "Diseña e implementa estrategias de promoción digital para productos y servicios turísticos mediante el uso de redes sociales y plataformas tecnológicas.",
          evidencias: [
            {
              tipo: "Informe / Portafolio / Certificado laboral / Certificados académicos",
              items: [
                "Informe, portafolio o certificado laboral que demuestre experiencia en redes sociales, promoción digital, manejo de plataformas (WhatsApp Business, Facebook, etc.) o contenido turístico.",
                "Evidencias documentales, declaración juramentada y/o certificado de trabajo.",
                "Certificados en marketing digital o redes sociales (mínimo 144 horas) emitidos por instituciones reconocidas.",
              ],
            },
          ],
        },
        {
          nombre: "Valoración del Potencial Turístico",
          resultadoAprendizaje:
            "Identifica y evalúa el potencial turístico mediante el análisis de atractivos, patrimonio y diseño de productos turísticos sostenibles.",
          evidencias: [
            {
              tipo: "Informe / Portafolio / Certificado laboral / Certificados académicos",
              items: [
                "Informe, portafolio o certificado laboral que evidencie experiencia en desarrollo de productos turísticos, identificación de atractivos, rutas, guianza, interpretación del patrimonio o servicios turísticos.",
                "Evidencias documentales, declaración juramentada y/o certificado de trabajo.",
                "Certificados en turismo cultural, patrimonio, promoción o productos turísticos (mínimo 144 horas) emitidos por instituciones reconocidas.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia3_turismo = [
    {
      id: 3,
      titulo:
        "Analizar la oferta turística mediante el uso de herramientas digitales de vanguardia, metodologías de investigación y tecnologías inmersivas, para crear proyectos turísticos innovadores y sostenibles que enriquezcan los destinos y negocios turísticos con valor agregado.",
      asignaturas: [
        {
          nombre: "Productos Turísticos Innovadores",
          resultadoAprendizaje:
            "Aplica tecnologías inmersivas y maneja redes sociales para optimizar la promoción y experiencia en destinos turísticos.",
          evidencias: [
            {
              tipo: "Informe / Portafolio / Certificado laboral / Certificados académicos",
              items: [
                "Informe, portafolio o certificado laboral que demuestre experiencia en diseño o promoción de experiencias turísticas, uso de herramientas digitales, redes sociales o tecnologías innovadoras en el sector.",
                "Evidencias documentales, declaración juramentada y/o certificado de trabajo.",
                "Certificados en innovación turística, experiencias turísticas, herramientas digitales o marketing experiencial (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Estrategias y Comunicación en Redes Sociales",
          resultadoAprendizaje:
            "Elabora estrategias de contenido digital ejecutando la planificación estratégica para impulsar la presencia en el turismo digital.",
          evidencias: [
            {
              tipo: "Informe / Portafolio / Certificado laboral / Certificados académicos",
              items: [
                "Informe, portafolio o certificado laboral que demuestre planificación, gestión o ejecución de estrategias de contenido en redes sociales para empresas turísticas o de servicios.",
                "Evidencias como publicaciones, métricas, diseños, declaración juramentada y/o certificado de trabajo.",
                "Certificados en redes sociales, planificación de contenido o comunicación digital (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Tecnologías Inmersivas y conectividad",
          resultadoAprendizaje:
            "Integra tecnologías inmersivas y herramientas digitales innovadoras para fortalecer la promoción y experiencia turística.",
          evidencias: [
            {
              tipo: "Informe / Portafolio / Certificado laboral / Certificados académicos",
              items: [
                "Informe, portafolio o certificado laboral que evidencie uso de realidad aumentada, recorridos virtuales, apps interactivas, códigos QR u otras tecnologías aplicadas a la promoción o experiencia turística.",
                "Evidencias documentales, declaración juramentada y/o certificado de trabajo.",
                "Certificados en tecnologías turísticas, realidad aumentada, conectividad o herramientas digitales (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Marketing de Contenidos",
          resultadoAprendizaje:
            "Diseña y ejecuta estrategias de contenido creativo para la promoción turística mediante formatos digitales innovadores.",
          evidencias: [
            {
              tipo: "Informe / Portafolio / Certificado laboral / Certificados académicos",
              items: [
                "Informe, portafolio o certificado laboral que evidencie creación de contenido para promoción turística: textos, imágenes, videos, blogs, reels, storytelling o fotografía aplicada.",
                "Adjuntar muestras, enlaces, declaración juramentada y/o certificado de trabajo.",
                "Certificados en creación de contenido, fotografía turística o storytelling (mínimo 144 horas).",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia4_turismo = [
    {
      id: 4,
      titulo:
        "Ejecutar planes de marketing turístico digital estratégicos, integrando tecnologías emergentes y plataformas de información para el lanzamiento y promoción de servicios turísticos que respondan a las tendencias del mercado y las preferencias de los consumidores.",
      asignaturas: [
        {
          nombre: "Planificación y Desarrollo Estratégico",
          resultadoAprendizaje:
            "Maneja aplicaciones móviles innovadoras diseñando estrategias de comunicación digital para la promoción eficaz de destinos turísticos.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "Esta asignatura no es validable para proceso de reconocimiento por evidencias.",
              ],
            },
          ],
        },
        {
          nombre: "Competencias Humanas para el Futuro",
          resultadoAprendizaje:
            "Utiliza inteligencia de mercado y análisis de datos para optimizar estrategias y planes de marketing turístico digital.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "Esta asignatura no es validable para proceso de reconocimiento por evidencias.",
              ],
            },
          ],
        },
        {
          nombre: "Apps para el Turismo",
          resultadoAprendizaje:
            "Implementa y gestiona aplicaciones móviles y plataformas digitales para fortalecer la promoción y comercialización de servicios turísticos.",
          evidencias: [
            {
              tipo: "Informe / Portafolio / Certificado laboral / Certificados académicos",
              items: [
                "Informe, portafolio o certificado laboral que evidencie uso o gestión de apps turísticas como Google Maps, Booking, Airbnb, Tripadvisor, Civitatis, entre otras.",
                "Adjuntar capturas, enlaces, declaración juramentada y/o certificado de trabajo.",
                "Certificados en uso de apps turísticas, plataformas digitales o herramientas móviles (mínimo 144 horas).",
              ],
            },
          ],
        },
        {
          nombre: "Inteligencia de Mercados y Análisis de Datos de Turismo",
          resultadoAprendizaje:
            "Analiza datos de mercado turístico para optimizar estrategias digitales y toma de decisiones basadas en información.",
          evidencias: [
            {
              tipo: "Informe / Portafolio / Certificado laboral / Certificados académicos",
              items: [
                "Informe, portafolio o certificado laboral que evidencie levantamiento o análisis de datos de clientes, encuestas, tendencias de viajeros, estadísticas de reservas o perfiles de mercado turístico.",
                "Adjuntar evidencias, declaración juramentada y/o certificado de trabajo.",
                "Certificados en análisis de datos, estudios de mercado o inteligencia comercial aplicados al turismo (mínimo 144 horas).",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia1_contabilidad = [
    {
      id: 1,
      titulo:
        "Interpretar y aplicar correctamente los principios contables y la normativa tributaria vigente para generar información económica-financiera precisa, confiable y oportuna, que contribuya a la toma de decisiones y al cumplimiento de las obligaciones fiscales con criterio y ética profesional.",
      asignaturas: [
        {
          nombre: "Contabilidad General",
          resultadoAprendizaje:
            "Aplica de manera efectiva los principios contables fundamentales para el registro, análisis y presentación de información económico-financiera precisa y confiable de una organización.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional, continua o acumulada, en funciones contables, tributarias o actividades afines.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Documento estructurado que detalle funciones desempeñadas, herramientas empleadas, portales institucionales y organismos de control utilizados.",
                "Descripción del software contable aplicado en el ejercicio profesional.",
                "Logros alcanzados y responsabilidades asumidas en áreas contables y afines.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
        {
          nombre: "Tributación Nacional: Imposición Indirecta",
          resultadoAprendizaje:
            "Interpreta la normativa tributaria vigente relacionada con los impuestos directos e indirectos en el contexto nacional y la aplica correctamente en la práctica contable para contribuir al cumplimiento de las obligaciones fiscales.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional en funciones contables y tributarias.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Detalle de gestión de declaraciones tributarias y cumplimiento de obligaciones fiscales.",
                "Manejo de portales institucionales y organismos de control.",
                "Aplicación de normativa fiscal vigente y uso de software contable y tributario.",
                "Responsabilidades asumidas y logros alcanzados.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
        {
          nombre: "Competencias Humanas para el Futuro",
          resultadoAprendizaje:
            "Aplica las competencias humanas desarrolladas a su propio campo de conocimiento.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "Esta asignatura no es validable para proceso de reconocimiento por evidencias.",
              ],
            },
          ],
        },
        {
          nombre: "Gestión Empresarial y Teorías de la Organización",
          resultadoAprendizaje:
            "Aplica herramientas y técnicas financieras y presupuestarias para gestionar los recursos de la empresa de manera responsable y maximizar su valor económico.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional en actividades de gestión empresarial o afines.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Detalle de experiencia en actividades de gestión empresarial.",
                "Aplicación de principios administrativos y análisis de estructuras organizacionales.",
                "Implementación de procesos de planificación, dirección y control.",
                "Uso de herramientas de gestión para optimización del desempeño organizacional.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia2_contabilidad = [
    {
      id: 2,
      titulo:
        "Aplicar con responsabilidad el marco legal vigente que deben cumplir los entes económicos, incluyendo las Normas Internacionales de Información Financiera (NIIF), así como la normativa tributaria nacional, integrando herramientas de innovación y análisis de datos para la toma de decisiones.",
      asignaturas: [
        {
          nombre: "Contabilidad Financiera",
          resultadoAprendizaje:
            "Aplica las Normas Internacionales de Información Financiera (NIIF) en la medición de los elementos contables y en la elaboración de estados financieros que reflejen fielmente la situación económico-financiera, para facilitar la toma de decisiones.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional, continua o acumulada, en funciones contables, tributarias o actividades afines.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Detalle estructurado de funciones desempeñadas en aplicación de NIIF.",
                "Herramientas y software contable utilizados.",
                "Elaboración y análisis de estados financieros.",
                "Logros alcanzados y responsabilidades asumidas en el área financiera.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
        {
          nombre: "Tributación Nacional: Imposición Directa",
          resultadoAprendizaje:
            "Interpreta la normativa tributaria vigente relacionada con los impuestos directos e indirectos en el contexto nacional y su correcta aplicación en la práctica contable para contribuir al cumplimiento de las obligaciones fiscales.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional en funciones contables y tributarias.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Gestión y presentación de declaraciones de impuestos directos.",
                "Manejo de portales institucionales y organismos de control.",
                "Aplicación de normativa tributaria vigente.",
                "Uso de software contable y tributario.",
                "Responsabilidades asumidas y logros alcanzados.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
        {
          nombre: "Emprendimiento e Innovación",
          resultadoAprendizaje:
            "Emplea la creatividad para generar ideas de negocio innovadoras que impulsen el desarrollo empresarial.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional o emprendedora en el desarrollo de iniciativas empresariales.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional o emprendedora",
              items: [
                "Descripción de creación, gestión o fortalecimiento de proyectos empresariales.",
                "Aplicación de estrategias innovadoras.",
                "Uso de herramientas para generación de valor y sostenibilidad organizacional.",
                "Resultados obtenidos y responsabilidades asumidas.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional o emprendedora descrita.",
              ],
            },
          ],
        },
        {
          nombre: "Inteligencia de Negocios",
          resultadoAprendizaje:
            "Utiliza herramientas tecnológicas en Business Analytics, Big Data y estadística aplicada para visualizar datos y generar informes ejecutivos que faciliten la toma de decisiones.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "Esta asignatura no es validable por corresponder a competencias transversales del modelo UTPL-TEC.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia3_contabilidad = [
    {
      id: 3,
      titulo:
        "Utilizar tecnologías de la información aplicadas a la contabilidad y tributación, incluyendo software contables especializados y plataformas de los organismos de control, para cumplir con el marco legal vigente y optimizar la gestión financiera y empresarial.",
      asignaturas: [
        {
          nombre: "Contabilidad Analítica",
          resultadoAprendizaje:
            "Utiliza técnicas y procedimientos para identificar costos relevantes e implementar sistemas de costos eficientes, con el fin de tomar decisiones gerenciales informadas y optimizar los recursos de una empresa.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional, continua o acumulada, en funciones contables, tributarias o actividades afines.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Experiencia en contabilidad analítica y aplicación de métodos de costeo.",
                "Análisis de costos y márgenes de rentabilidad.",
                "Elaboración de informes de control interno.",
                "Uso de herramientas contables para la gestión eficiente de recursos.",
                "Logros alcanzados y responsabilidades asumidas.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
        {
          nombre: "Legislación Empresarial",
          resultadoAprendizaje:
            "Aplica el marco legal vigente que regula a las empresas en el contexto nacional, así como la utilización de plataformas de los organismos de control para cumplir con las obligaciones legales establecidas.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional en funciones contables, tributarias o actividades afines.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Detalle estructurado de funciones relacionadas con cumplimiento legal empresarial.",
                "Manejo de portales institucionales y organismos de control.",
                "Aplicación de normativa empresarial vigente.",
                "Uso de software contable y administrativo.",
                "Logros alcanzados y responsabilidades asumidas.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
        {
          nombre: "Gestión Financiera y Presupuestaria",
          resultadoAprendizaje:
            "Aplica herramientas y técnicas financieras y presupuestarias para gestionar los recursos de la empresa de manera responsable y maximizar su valor económico.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional en actividades de gestión financiera, presupuestaria o afines.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Elaboración, ejecución y control de presupuestos.",
                "Análisis e interpretación de estados financieros.",
                "Aplicación de herramientas de planificación financiera.",
                "Toma de decisiones en el ámbito económico-administrativo.",
                "Logros alcanzados y responsabilidades asumidas.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
        {
          nombre: "Software Aplicado a la Gestión de los Negocios",
          resultadoAprendizaje:
            "Utiliza software especializados en el ámbito empresarial para optimizar procesos, gestionar información y mejorar la toma de decisiones en diferentes áreas funcionales de una organización.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional en el uso de software empresarial en funciones contables, tributarias o administrativas.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Detalle de software especializados utilizados en la gestión empresarial.",
                "Optimización de procesos mediante herramientas tecnológicas.",
                "Gestión de información financiera y administrativa.",
                "Uso de plataformas de organismos de control.",
                "Logros alcanzados y responsabilidades asumidas.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia4_contabilidad = [
    {
      id: 4,
      titulo:
        "Analizar e interpretar datos económicos y financieros utilizando herramientas de Business Analytics, Big Data y técnicas de evaluación financiera, para la toma de decisiones fundamentadas que contribuyan a la sostenibilidad y eficiencia de los entes económicos.",
      asignaturas: [
        {
          nombre: "NIIF e Incidencia Tributaria",
          resultadoAprendizaje:
            "Analiza las implicaciones fiscales derivadas de la implementación de las Normas Internacionales de Información Financiera (NIIF), contribuyendo a la gestión eficiente de la carga tributaria de las empresas.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional, continua o acumulada, en funciones contables, tributarias o actividades afines.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Detalle estructurado de funciones relacionadas con aplicación de NIIF y su incidencia tributaria.",
                "Análisis de implicaciones fiscales derivadas de la implementación de NIIF.",
                "Uso de herramientas contables y portales de organismos de control.",
                "Logros alcanzados y responsabilidades asumidas en áreas contables y tributarias.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
        {
          nombre: "Evaluación Financiera para las Organizaciones",
          resultadoAprendizaje:
            "Aplica técnicas de evaluación financiera para determinar la viabilidad y rentabilidad de proyectos de inversión y tomar decisiones empresariales basadas en criterios financieros sólidos.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional en funciones contables, financieras o tributarias.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Experiencia en análisis de inversiones y valoración de proyectos.",
                "Aplicación de indicadores financieros.",
                "Elaboración de reportes financieros para toma de decisiones.",
                "Logros alcanzados y responsabilidades asumidas.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
        {
          nombre: "Estadística Aplicada a los Negocios",
          resultadoAprendizaje:
            "Utiliza herramientas tecnológicas en Business Analytics, Big Data y estadística aplicada para visualizar datos y generar informes ejecutivos que faciliten la toma de decisiones.",
          evidencias: [
            {
              tipo: "Certificados laborales",
              items: [
                "Documentos que acrediten al menos dos (2) años de experiencia profesional en análisis de datos aplicados a la gestión empresarial.",
              ],
            },
            {
              tipo: "Informe descriptivo de experiencia profesional",
              items: [
                "Aplicación de métodos y técnicas estadísticas en gestión empresarial.",
                "Uso de herramientas estadísticas y de análisis de datos.",
                "Elaboración de reportes cuantitativos para toma de decisiones.",
                "Logros alcanzados y responsabilidades asumidas.",
              ],
            },
            {
              tipo: "Declaración juramentada",
              items: [
                "Declaración juramentada que respalde la experiencia profesional descrita.",
              ],
            },
          ],
        },
        {
          nombre: "Gestión Basada en Datos y Análisis Empresarial",
          resultadoAprendizaje:
            "Utiliza herramientas tecnológicas en Business Analytics y análisis de datos empresariales para apoyar la toma de decisiones estratégicas.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "Esta asignatura no es validable por corresponder a competencias transversales del modelo UTPL-TEC.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia0_comunicacion = [
    {
      id: 0,
      titulo:
        "Aplica las competencias humanas desarrolladas a su propio campo de conocimiento.",
      asignaturas: [
        {
          nombre: "Competencias Humanas para el Futuro",
          resultadoAprendizaje:
            "Aplica las competencias humanas desarrolladas a su propio campo de conocimiento.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "No validable, sus contenidos son propios de la filosofía institucional de la UTPL.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia1_audiovisual = [
    {
      id: 1,
      titulo:
        "Identificar los fundamentos de la narrativa persuasiva, aplicando análisis crítico y técnicas de redacción para desarrollar contenidos que atraigan e impacten al público, aprovechando eficientemente las plataformas digitales y nuevas tecnologías.",
      asignaturas: [
        {
          nombre: "Storytelling",
          resultadoAprendizaje:
            "Aplica técnicas de redacción creativa y persuasiva para elaborar guiones y textos que comuniquen efectivamente mensajes específicos.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "No validable, al ser un área novedosa dentro de la comunicación persuasiva.",
              ],
            },
          ],
        },
        {
          nombre: "Narrativa Audiovisual",
          resultadoAprendizaje:
            "Evalúa proyectos audiovisuales desde perspectivas técnica, narrativa, ética y social.",
          evidencias: [
            {
              tipo: "Certificados / Portafolio / Publicaciones",
              items: [
                "Certificados laborales como director, editor, montajista, analista o crítico audiovisual.",
                "Portafolio de análisis narrativo y visual.",
                "Publicaciones, blogs o ensayos sobre crítica audiovisual.",
                "Participación en festivales como jurado o crítico.",
              ],
            },
          ],
        },
        {
          nombre: "Guionización",
          resultadoAprendizaje:
            "Aplica técnicas de redacción creativa y persuasiva para elaborar guiones audiovisuales.",
          evidencias: [
            {
              tipo: "Guiones / Certificados / Registro autoría",
              items: [
                "Mínimo 2 guiones desarrollados en proyectos ejecutados.",
                "Registro en SENADI.",
                "Certificados laborales como guionista.",
                "Portafolio de proyectos escritos.",
              ],
            },
          ],
        },
        {
          nombre: "Gestión de Actores",
          resultadoAprendizaje:
            "Colabora en equipos interdisciplinarios para la producción audiovisual.",
          evidencias: [
            {
              tipo: "Certificados / Portafolio / Evidencia audiovisual",
              items: [
                "Participación en al menos 2 producciones.",
                "Videos backstage.",
                "Testimonios o recomendaciones.",
                "Experiencia mínima de 2 años.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia2_audiovisual = [
    {
      id: 2,
      titulo:
        "Diseñar productos audiovisuales digitales integrando tecnologías avanzadas e innovación para maximizar impacto y relevancia.",
      asignaturas: [
        {
          nombre: "Técnicas Sonoras Digitales",
          resultadoAprendizaje:
            "Diseña productos sonoros aplicando herramientas digitales especializadas.",
          evidencias: [
            {
              tipo: "Portafolio / Certificados",
              items: [
                "Mínimo 3 piezas sonoras.",
                "Certificados laborales como técnico de sonido.",
                "Licencias de software (Pro Tools, Reaper, Audition).",
                "2 años de experiencia mínima.",
              ],
            },
          ],
        },
        {
          nombre: "Fotografía Digital",
          resultadoAprendizaje:
            "Diseña contenidos audiovisuales innovadores mediante herramientas de producción digital.",
          evidencias: [
            {
              tipo: "Portafolio fotográfico",
              items: [
                "Mínimo 10 piezas propias.",
                "Certificados laborales como fotógrafo.",
                "Publicaciones o premios.",
                "2 años de experiencia mínima.",
              ],
            },
          ],
        },
        {
          nombre: "Producción Audiovisual",
          resultadoAprendizaje:
            "Diseña contenidos audiovisuales innovadores utilizando herramientas de producción digital.",
          evidencias: [
            {
              tipo: "Portafolio / Certificados",
              items: [
                "Mínimo 2 proyectos completos.",
                "Planes de rodaje y presupuestos.",
                "Experiencia mínima de 2 años.",
              ],
            },
          ],
        },
        {
          nombre: "Producción para Plataformas",
          resultadoAprendizaje:
            "Adapta contenidos audiovisuales para diversas plataformas digitales.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "No validable, asignatura nueva enfocada en plataformas digitales.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia3_audiovisual = [
    {
      id: 3,
      titulo:
        "Planificar la implementación efectiva de productos audiovisuales desde su conceptualización hasta su realización.",
      asignaturas: [
        {
          nombre: "IA Aplicada a la Creación Audiovisual",
          resultadoAprendizaje:
            "Integra herramientas de inteligencia artificial en la creación audiovisual.",
          evidencias: [
            {
              tipo: "No aplica",
              items: ["No validable, asignatura nueva y disruptiva."],
            },
          ],
        },
        {
          nombre: "Animación y Efectos",
          resultadoAprendizaje:
            "Aplica técnicas de animación y efectos visuales en producción audiovisual.",
          evidencias: [
            {
              tipo: "Portafolio / Certificados",
              items: [
                "Mínimo 3 piezas de animación.",
                "2 años de experiencia comprobable.",
                "Certificados en After Effects, Blender, etc.",
              ],
            },
          ],
        },
        {
          nombre: "Postproducción Audiovisual",
          resultadoAprendizaje:
            "Lidera o ejecuta procesos completos de edición y postproducción.",
          evidencias: [
            {
              tipo: "Portafolio / Certificados",
              items: [
                "Mínimo 3 piezas audiovisuales terminadas.",
                "Certificados laborales como editor/a.",
                "2 años de experiencia mínima.",
              ],
            },
          ],
        },
        {
          nombre: "Marketing Digital",
          resultadoAprendizaje:
            "Implementa estrategias de marketing innovadoras para productos audiovisuales.",
          evidencias: [
            {
              tipo: "Campañas / Certificados",
              items: [
                "Mínimo 3 años de experiencia.",
                "Campañas ejecutadas con métricas.",
                "Certificaciones Google Ads, Meta, Hubspot.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia4_audiovisual = [
    {
      id: 4,
      titulo:
        "Liderar la producción de narrativas audiovisuales innovadoras adaptándolas a diversas plataformas y audiencias.",
      asignaturas: [
        {
          nombre: "Herramientas de Medición y Control",
          resultadoAprendizaje:
            "Analiza métricas y desempeño de productos audiovisuales en plataformas digitales.",
          evidencias: [
            {
              tipo: "No aplica",
              items: [
                "No validable por depender de herramientas en constante evolución.",
              ],
            },
          ],
        },
        {
          nombre: "Publicidad Digital",
          resultadoAprendizaje:
            "Implementa estrategias de marketing innovadoras para productos audiovisuales.",
          evidencias: [
            {
              tipo: "Portafolio / Campañas",
              items: [
                "Mínimo 3 campañas digitales.",
                "2 años de experiencia mínima.",
                "Métricas de engagement.",
              ],
            },
          ],
        },
        {
          nombre: "Emprendimiento Digital",
          resultadoAprendizaje:
            "Posee habilidades empresariales y de comunicación esenciales para el emprendimiento.",
          evidencias: [
            {
              tipo: "Proyecto implementado",
              items: [
                "Emprendimiento audiovisual registrado.",
                "Plan de negocio ejecutado.",
                "Mínimo 2 años gestionando operación.",
              ],
            },
          ],
        },
      ],
    },
  ];
  return (
    <div>
      <Header></Header>
      <Banner></Banner>

      <div className="padding graybg">
        <center>
          <h3>
            Proceso de validación por experiencia laboral o trayectoria
            profesional{" "}
          </h3>
        </center>
        <ThreeColumns
          col1={
            <div>
              <div className="icon100">
                {" "}
                <img src={imagen1}></img>
              </div>

              <h4>
                Obtén tus <b> credenciales </b>
              </h4>

              <p>
                Si no cuentas con credenciales institucionales, regístrate en
                nuestro sistema de matrícula para obtenerlas y poder acceder al
                servicio de validación.
              </p>

              <a href="https://matriculas.utpl.edu.ec/" className="button">
                Crear credenciales
              </a>
              <br></br>
              <Accordion
                title="Conoce el proceso"
                content={
                  <>
                    <img src={paso1}></img>
                  </>
                }
              ></Accordion>
            </div>
          }
          col2={
            <div>
              <div className="icon100">
                {" "}
                <img src={oportunidaddes}></img>
              </div>
              <h4>
                Solicita el <b>análisis de tu documentación </b>
              </h4>
              <p>
                Reuné la evidencia solicitada, junto con los documentos que
                deben respaldar la validación. Luego, ingresa a nuestra
                plataforma de servicios institucionales y solicita el análisis
                de la información.
              </p>

              <p>
                Ten presente que toda la documentación debe estar integrada en
                un
                <b> único archivo en formato PDF.</b>{" "}
              </p>
              <p>
                <b> Costo:</b> $35
              </p>
              <br></br>
              <a
                target="_blank"
                href="https://www.utpl.edu.ec/carreras/sites/default/files/validacion-tec.pdf"
                className="link-with-arrow"
              >
                Conoce los documentos que deben respaldar la solicitud
              </a>
              <a href="#evidencias" className="link-with-arrow">
                Conoce las evidencias requeridas por cada asignatura
              </a>
              <a
                href="https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService"
                className="button"
              >
                Solicitar análisis
              </a>
              <br></br>
              <Accordion
                title="Conoce el proceso"
                content={
                  <>
                    <img src={paso2}></img>
                  </>
                }
              ></Accordion>
            </div>
          }
          col3={
            <div>
              <div className="icon100">
                {" "}
                <img src={consejero}></img>
              </div>
              <h4>
                Solicita el <b> reconocimiento de tu validación </b>
              </h4>
              <p>
                {" "}
                Si tu análisis es aprobado, te emitiremos un informe con el cual
                podrás gestionar el reconocimiento de las asignaturas que ya has
                aprobado.
              </p>
              <p>
                <b> Costo: </b>$35 por asignatura, con un tope máximo de 10
                asignaturas. Si se validan más no tendrá costo adicional.
              </p>
              <a
                href="https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService"
                className="button"
              >
                Solicitar reconocimiento
              </a>
              <br></br>
              <Accordion
                title="Conoce el proceso"
                content={
                  <>
                    <img src={paso3}></img>
                  </>
                }
              ></Accordion>
            </div>
          }
        />
      </div>

      <div className=" padding" id="evidencias">
        <div className="layout9">
          <center>
            <h2>
              Conoce las evidencias requeridas para validar tu asignatura según
              tu carrera
            </h2>
            <h4>
              Tecnología Superior en{" "}
              <b>Comunicación Estratégica y Marketing Digital</b>
            </h4>{" "}
          </center>
          <div className="flex-start col2">
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia1}
              ></CompetenciaComponent>{" "}
            </div>
            <div className="item-component">
              <CompetenciaComponent datos={competencia2}></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent datos={competencia3}></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent datos={competencia4}></CompetenciaComponent>
            </div>
          </div>

          <div className="layout9">
            <p>
              Para la Tecnología Superior en Comunicación Estratégica y
              Marketing Digital, el prácticum debe gestionarse a través del
              servicio de Reconocimiento de Prácticum disponible en nuestros
              Servicios Institucionales. <a href="#contacto" className="link-with-arrow"> Consulta más información en nuestros canales oficiales</a>
            </p>

            
          </div>
          <center>
            {" "}
            <h4>
              Tecnología Superior en{" "}
              <b>Modelado BIM para la Industria de la Construcción</b>
            </h4>
          </center>

          <div className="flex-start col2">
            <div className="item-component">
              <CompetenciaComponent
                datos={bimcompetencia1}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={bimcompetencia2}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={bimcompetencia3}
              ></CompetenciaComponent>
            </div>
          </div>

          <div className="flex-start col2">
            <div className="item-component">
              <CompetenciaComponent
                datos={bimcompetencia4}
              ></CompetenciaComponent>
            </div>

            <div className="item-component">
              <CompetenciaComponent
                datos={bimcompetencia5}
              ></CompetenciaComponent>
            </div>
          </div>

          <center>
            <h4>
              Tecnología Superior en <b>Negociación y Ventas</b>
            </h4>
          </center>

          <div className="flex-start col2">
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia1_ventas}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia2_comercial}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia3_comercial}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia4_comercial}
              ></CompetenciaComponent>
            </div>
          </div>

          <center>
            <h4>
              Tecnología Superior en <b>Marketing Turístico Digital</b>
            </h4>
          </center>

          <div className="flex-start col2">
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia1_turismo}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia3_turismo}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia4_turismo}
              ></CompetenciaComponent>
            </div>
          </div>

          <center>
            <h4>
              Tecnología Superior en <b>Contabilidad y Asesoría Tributaria</b>
            </h4>
          </center>

          <div className="flex-start col2">
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia1_contabilidad}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia2_contabilidad}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia3_contabilidad}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia4_contabilidad}
              ></CompetenciaComponent>
            </div>
          </div>

          <center>
            <h4>
              Tecnología Superior en <b>Creación Audiovisual Digital</b>
            </h4>
          </center>

          <div className="flex-start col2">
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia1_audiovisual}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia2_audiovisual}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia3_audiovisual}
              ></CompetenciaComponent>
            </div>
            <div className="item-component">
              <CompetenciaComponent
                datos={competencia4_audiovisual}
              ></CompetenciaComponent>
            </div>
          </div>
        </div>
      </div>
      <div 
      id="contacto"
        className="padding"
        style={{
          backgroundColor: "#f5f5f5",

          textAlign: "center",
        }}
      >
        <h2>
          ¿Necesitas <b> más información?</b>
        </h2>
        <p style={{ margin: "0 0 8px 0" }}>Solicita asesoría virtual en:</p>

        <a
          href="https://utpl.edu.ec/zoom"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#0a4fa3", fontSize: "14pt" }}
        >
          utpl.edu.ec/zoom
        </a>

        <p style={{ margin: "8px 0 4px 0" }}>o al WhatsApp:</p>

        <a
          href="https://utpl.edu.ec/wha"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: "14pt", color: "#25D366" }}
        >
          utpl.edu.ec/wha
        </a>

        <a
          href="https://wa.me/593999565400"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "block", color: "#25D366", fontWeight: "600" }}
        >
          0999565400
        </a>
      </div>

      <Footer></Footer>
    </div>
  );
}

export default App;
